module.exports = __webpack_public_path__ + "img/30.718f67bc.png";